export default "__VITE_ASSET__Bulvwfag__"